import PropTypes from "prop-types";

import { strCode } from "../../../../consts";
import { t } from "../../../../services";

import {
  FlexContainers,
  Modal,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../../../components";

const DeleteLanguageModal = ({ active, setActive, title, onDelete }) => {
  return (
    <Modal
      id="delete-language-modal"
      title={t(strCode.DELETE_LANGUAGE_MODAL_TITLE)}
      active={active}
      setActive={setActive}
      closable>
      <WrapperContainer maxWidth={335}>
        <Paragraph2
          dangerouslySetInnerHTML={{
            __html: `${t(strCode.DELETE_LANGUAGE_MODAL_TEXT_1)} <b>${title}</b>? ${t(
              strCode.DELETE_LANGUAGE_MODAL_TEXT_2
            )}`
          }}
        />

        <WrapperContainer Container={FlexContainers.FlexRowEnd} width={"100%"} gap={8} mt={16}>
          <SmallButton secondary onClick={() => setActive(false)}>
            {t(strCode.CANCEL_BTN)}
          </SmallButton>
          <SmallButton
            backgroundRed
            onClick={() => {
              setActive(false);
              onDelete();
            }}>
            {t(strCode.DELETE_BTN)}
          </SmallButton>
        </WrapperContainer>
      </WrapperContainer>
    </Modal>
  );
};

DeleteLanguageModal.propTypes = {
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default DeleteLanguageModal;
